import type { ToyConfig } from '../types';

export class SpawnSystem {
  private toys: ToyConfig[];
  private rarityWeights: Record<string, number> = { common: 0.6, rare: 0.3, legendary: 0.1 };
  private missStreakRare = 0;

  constructor(toys: ToyConfig[]) {
    this.toys = toys;
  }

  spawn(): ToyConfig {
    const rarity = this.pickRarity();
    const candidates = this.toys.filter((t) => t.rarity === rarity);
    const totalWeight = candidates.reduce((sum, t) => sum + t.spawnWeight, 0);
    let roll = Math.random() * totalWeight;

    for (const toy of candidates) {
      roll -= toy.spawnWeight;
      if (roll <= 0) return toy;
    }

    return candidates[0];
  }

  recordResult(success: boolean, rarity: string): void {
    if (success) {
      // Only reset streak when a rare or legendary is actually won
      if (rarity === 'rare' || rarity === 'legendary') {
        this.missStreakRare = 0;
      }
      return;
    }

    // Increment streak on any failed grab attempt
    this.missStreakRare += 1;
  }

  private pickRarity(): string {
    const weights = { ...this.rarityWeights };

    if (this.missStreakRare >= 20) {
      weights.legendary += 0.25;
      weights.rare += 0.35;
    } else if (this.missStreakRare >= 10) {
      weights.legendary += 0.05;
      weights.rare += 0.1;
    }

    const total = Object.values(weights).reduce((a, b) => a + b, 0);
    let roll = Math.random() * total;

    for (const [rarity, weight] of Object.entries(weights)) {
      roll -= weight;
      if (roll <= 0) return rarity;
    }

    return 'common';
  }
}
